import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// @ts-ignore
import './App.css';
// @ts-ignore
import './index.css';
import Header from './components/Header';
import Home from './components/Home';
import About from './components/About';
import Join from './components/Join';
import Why from './components/Why';
import NotFound from './components/NotFound';
import Footer from './components/Footer';
import ScrollToTopButton from './components/ScrollToTopButton';
import PasswordGate from './components/PasswordGate';
import usePageTracking from './hooks/usePageTracking';

const PageTracker: React.FC = () => { usePageTracking(); return null; };

const App: React.FC = () => (
  <PasswordGate>
  <Router>
    <PageTracker />
    <Header />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/warum" element={<Why />} />
      <Route path="/join" element={<Join />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
    <Footer />
    <ScrollToTopButton />
  </Router>
  </PasswordGate>
);

export default App;
